import Typography from '@/components/atoms/typography/typography';
import TeaserRow from '@/components/modules/teaser-grid/teaser-row/teaser-row';
import Column from '@/components/utilities/column/column';
import Container from '@/components/utilities/container/container';
import ModuleWrapper, {
  ModuleWrapperProps,
} from '@/components/utilities/module-wrapper/module-wrapper';
import Row from '@/components/utilities/row/row';
import styles from './teaser-grid.module.scss';

export interface TeaserGridProps extends ModuleWrapperProps {
  /** The headline of the module */
  headline: Content.Components['TeaserGridModuleDto']['headline'];
  /** Items to show as cards in the grid */
  rows: Content.Components['TeaserGridModuleDto']['rows'];
}

const TeaserGrid = ({ headline, rows, ...rest }: TeaserGridProps) => {
  return (
    <ModuleWrapper {...rest} className={styles.component}>
      <Container>
        <Row className={styles.rowWrapper}>
          <Column>
            <Typography
              className={styles.headline}
              tag="h2"
              tagStyle="displayMedium"
            >
              {headline}
            </Typography>
          </Column>

          {rows.map((row, rowIndex) => (
            <Column key={rowIndex}>
              <TeaserRow items={row.items} rowIndex={rowIndex} />
            </Column>
          ))}
        </Row>
      </Container>
    </ModuleWrapper>
  );
};

TeaserGrid.displayName = 'TeaserGrid';

export default TeaserGrid;
